export const CONFIGURATOR_STATE_VERSION = "5.3.0";

export const CHART_CONFIG_VERSION = "5.3.0";
